<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group label-for="input-contact-name">
      <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
       <b-form-input
        id="input-contact-name"
        type="text"
        v-model="name"      
        required
        minlength="2"
        maxlength="100"
        :pattern=fullNamePattern
        @invalid="$event.target.setCustomValidity($t('FormatInvalidName'))"
        @input.native="$event.target.setCustomValidity('')"
      />
    </b-form-group>
    <b-form-group label-for="input-contact-email">
      <template v-slot:label>Email <span class="text-danger">*</span></template>
      <b-form-input id="input-contact-email" type="email" v-model.trim="email" name="email" required maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group label-for="input-contact-phone" :label="$t('phoneNumber')">
      <b-form-input id="input-contact-phone" type="tel" v-model.trim="phone" name="phone" :pattern="phonePattern" maxlength="50"
                    @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                    @input.native="$event.target.setCustomValidity('')" />
    </b-form-group>
    <b-form-group label-for="input-contact-title" :label="$t('workTitle')">
      <b-form-input id="input-contact-title" type="text" v-model="title" name="title" maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group label-for="input-contact-department" :label="$t('workDepartment')">
      <b-form-input id="input-contact-department" type="text" v-model="department" name="department" maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group label-for="input-contact-organization" :label="$t('workOrganization')">
      <b-form-input id="input-contact-organization" type="text" v-model="organization" name="organization" maxlength="100"></b-form-input>
    </b-form-group>
    <!-- <b-form-group label-for="input-contact-userCode" label="userCode" v-if="activeFID==1">
      <b-form-input id="input-contact-organization" type="text" v-model="userCode" name="userCode" maxlength="10"></b-form-input>
    </b-form-group> -->
    <b-form-group label-for="input-contact-organization" :label="$t('faceImage')" v-if="activeFID==1">
      <b-form-file v-model="fileImage" accept="image/*" @input="change" placeholder=""/>
      <b-img thumbnail fluid :src="url"></b-img>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as contactService from "@/service/contactService";
  import * as validationUtils from "@/service/validationUtils";
  import {enumErrorType} from "@/views/enums/ErrorType";

  @Component
  export default class EditContactModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;
    @Prop({ required: true }) contact: any;    
    @Prop({ required: true }) activeFID: any;
     @Prop({ default: [] }) contacts;

    name = "";
    email = "";
    phone = "";
    title = "";
    department = "";
    organization = "";
    userCode = "";

    formErrorMsg = "";
    isSubmitting = false;

    fileImage: File = null;
    url = "";
    // Emit decorators only
    @Emit("submitted") __submitted() {}


    mounted() {
      // Copy props from original object
      this.name = this.contact.name;
      this.email = this.contact.email;
      this.phone = this.contact.phone;
      this.title = this.contact.title;
      this.department = this.contact.department;
      this.organization = this.contact.organization;
    }

    change(file: File) {
      var tmppath = URL.createObjectURL(file);
      this.url = tmppath;
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = "";
      this.name = this.name.trim();
      this.title = this.title?.trim() || '';
      this.department = this.department?.trim() || '';
      this.organization = this.organization?.trim() || '';

      if (this.contacts.find(obj => obj.email.toLowerCase() === this.email.toLowerCase() && obj.id!== this.contact.id)) {
      this.formErrorMsg = this.$t("trungemail").toString();
      return;
    }
      if (this.contacts.find(obj => obj.phone === this.phone && obj.id!== this.contact.id)) {
      this.formErrorMsg = this.$t("trungsdt").toString();
      return;
    }
      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg = this.$t("invalidEmail").toString();
        return;
      }

      const data = {
        id: this.contact.id,
        name: this.name.trim(),
        email: this.email.trim().toLowerCase(),
        phone: this.phone.trim(),
        title: this.title.trim(),
        department: this.department.trim(),
        organization: this.organization.trim(),
      };

      try {
          this.isSubmitting = true;
          await contactService.updateContact(data);
          if(this.activeFID==1 && this.fileImage!= null) {
            await contactService.UpdateImageContact(this.fileImage, this.contact.id);
          }
          this.__submitted();
          this.toastSuccessDelay(this.$t("updateSuccessful").toString());
          this.$bvModal.hide(this.modalId);
        } 
        catch (e) {
          this.formErrorMsg = this.showError(e, enumErrorType.MESSAGE);
          //this.toastError(nameErrorMsg);  
        } finally {
          this.isSubmitting = false;
      }
    }

  }
</script>
